<template>
  <section class="section pt-1 bg-white">
    <div class="container">
      <h1 class="mb-4">{{ $t("help.platform.organization-members.text") }}</h1>

      <div role="tablist">
        <b-card no-body class="shadow-none mb-3">
          <b-card-body>
            <p class="mb-3">
              {{ $t("help.platform.organization-members.line-1") }}
            </p>

            <img src="@/assets/images/help/organization-members.png" class="image" />
          </b-card-body>
        </b-card>

        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col1' ? 'founded' : ''" v-b-toggle.col1>
              <div>
                {{ $t("help.platform.organization-members.invite.text") }}
              </div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col1" :visible="col == 'col1'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-3">
                {{ $t("help.platform.organization-members.invite.line-1") }}
              </p>

              <!-- <h5 class="mt-5">{{$t("help.organization.create.sample-screen")}}</h5> -->
              <img src="@/assets/images/help/invite-member.png" class="image" />
              <p class="mt-3">
                {{ $t("help.platform.organization-members.invite.line-2") }}
              </p>
              <a class="mt-3" href="/organization/members">
                <p><i class="bx bx-support"></i> {{ $t("help.platform.organization-members.invite.line-3") }}</p>
              </a>
              <p class="mt-3 mb-3">
                {{ $t("help.platform.organization-members.invite.line-4") }}
              </p>

              <img src="@/assets/images/help/invite-mail.png" class="image" />
              <p class="mt-3">
                {{ $t("help.platform.organization-members.invite.line-5") }}
              </p>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col2' ? 'founded' : ''" v-b-toggle.col2>
              <div>
                {{ $t("help.platform.organization-members.import.text") }}
              </div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col2" :visible="col == 'col2'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-3">
                {{ $t("help.platform.organization-members.import.line-1") }}
              </p>

              <!-- <h5 class="mt-5">{{$t("help.organization.create.sample-screen")}}</h5> -->
              <img src="@/assets/images/help/member-import.png" class="image" />
              <p class="mt-3">
                {{ $t("help.platform.organization-members.import.line-2") }}
              </p>
              <a class="mt-3" href="/organization/members">
                <p><i class="bx bx-support"></i> {{ $t("help.platform.organization-members.import.line-3") }}</p>
              </a>
              <p class="mt-3 mb-3">
                {{ $t("help.platform.organization-members.import.line-4") }}
              </p>

              <img src="@/assets/images/help/invite-mail.png" class="image" />
              <p class="mt-3">
                {{ $t("help.platform.organization-members.import.line-5") }}
              </p>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col3' ? 'founded' : ''" v-b-toggle.col3>
              <div>
                {{ $t("help.platform.organization-members.roles.text") }}
              </div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col3" :visible="col == 'col3'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-3">
                {{ $t("help.platform.organization-members.roles.line-1") }}
              </p>
              <p class="mb-3">
                {{ $t("help.platform.organization-members.roles.line-2") }}
              </p>
              <p class="mb-3">
                {{ $t("help.platform.organization-members.roles.line-3") }}
              </p>
              <h4 class="mb-3">
                {{ $t("help.platform.organization-members.roles.line-4") }}
              </h4>

              <ul class="mb-3">
                <li>
                  {{ $t("help.platform.organization-members.roles.line-5") }}
                </li>
                <li>
                  {{ $t("help.platform.organization-members.roles.line-6") }}
                </li>
                <li>
                  {{ $t("help.platform.organization-members.roles.line-7") }}
                </li>
                <li>
                  {{ $t("help.platform.organization-members.roles.line-8") }}
                </li>
                <li>
                  {{ $t("help.platform.organization-members.roles.line-9") }}
                </li>
              </ul>
              <img src="@/assets/images/help/owner-mark.png" class="image" />

              <h4 class="mb-3 mt-3">
                {{ $t("help.platform.organization-members.roles.line-10") }}
              </h4>

              <ul class="mb-3">
                <li>
                  {{ $t("help.platform.organization-members.roles.line-11") }}
                </li>
                <li>
                  {{ $t("help.platform.organization-members.roles.line-12") }}
                </li>
              </ul>
              <h4 class="mb-3 mt-3">
                {{ $t("help.platform.organization-members.roles.line-13") }}
              </h4>

              <ul class="mb-3">
                <li>
                  {{ $t("help.platform.organization-members.roles.line-14") }}
                </li>
                <li>
                  {{ $t("help.platform.organization-members.roles.line-15") }}
                </li>
                <li>
                  {{ $t("help.platform.organization-members.roles.line-16") }}
                </li>
                <li>
                  {{ $t("help.platform.organization-members.roles.line-17") }}
                </li>
                <li>
                  {{ $t("help.platform.organization-members.roles.line-18") }}
                </li>
              </ul>

              <h4 class="mb-3 mt-3">
                {{ $t("help.platform.organization-members.roles.line-19") }}
              </h4>

              <ul class="mb-3">
                <li>
                  {{ $t("help.platform.organization-members.roles.line-20") }}
                </li>
                <li>
                  {{ $t("help.platform.organization-members.roles.line-21") }}
                </li>
                <li>
                  {{ $t("help.platform.organization-members.roles.line-22") }}
                </li>
                <li>
                  {{ $t("help.platform.organization-members.roles.line-23") }}
                </li>
                <li>
                  {{ $t("help.platform.organization-members.roles.line-24") }}
                </li>
                <li>
                  {{ $t("help.platform.organization-members.roles.line-25") }}
                </li>
              </ul>

              <h4 class="mb-3 mt-3">
                {{ $t("help.platform.organization-members.roles.line-26") }}
              </h4>

              <ul class="mb-3">
                <li>
                  {{ $t("help.platform.organization-members.roles.line-27") }}
                </li>
                <li>
                  {{ $t("help.platform.organization-members.roles.line-28") }}
                </li>
                <li>
                  {{ $t("help.platform.organization-members.roles.line-29") }}
                </li>
                <li>
                  {{ $t("help.platform.organization-members.roles.line-30") }}
                </li>
                <li>
                  {{ $t("help.platform.organization-members.roles.line-31") }}
                </li>
              </ul>

              <h4 class="mb-3 mt-3">
                {{ $t("help.platform.organization-members.roles.line-32") }}
              </h4>

              <ul class="mb-3">
                <li>
                  {{ $t("help.platform.organization-members.roles.line-33") }}
                </li>
                <li>
                  {{ $t("help.platform.organization-members.roles.line-34") }}
                </li>
                <li>
                  {{ $t("help.platform.organization-members.roles.line-35") }}
                </li>
                <li>
                  {{ $t("help.platform.organization-members.roles.line-36") }}
                </li>
                <li>
                  {{ $t("help.platform.organization-members.roles.line-37") }}
                </li>
              </ul>
              <h4 class="mb-3 mt-3">
                {{ $t("help.platform.organization-members.roles.line-38") }}
              </h4>

              <ul class="mb-3">
                <li>
                  {{ $t("help.platform.organization-members.roles.line-39") }}
                </li>
                <li>
                  {{ $t("help.platform.organization-members.roles.line-40") }}
                </li>
                <li>
                  {{ $t("help.platform.organization-members.roles.line-41") }}
                </li>
                <li>
                  {{ $t("help.platform.organization-members.roles.line-42") }}
                </li>
                <li>
                  {{ $t("help.platform.organization-members.roles.line-43") }}
                </li>
              </ul>

              <h4 class="mb-3 mt-3">
                {{ $t("help.platform.organization-members.roles.line-44") }}
              </h4>

              <ul class="mb-3">
                <li>
                  {{ $t("help.platform.organization-members.roles.line-45") }}
                </li>
                <li>
                  {{ $t("help.platform.organization-members.roles.line-46") }}
                </li>
              </ul>

              <h4 class="mb-3 mt-3">
                {{ $t("help.platform.organization-members.roles.line-44") }}
              </h4>

              <ul class="mb-3">
                <li>
                  {{ $t("help.platform.organization-members.roles.line-45") }}
                </li>
                <li>
                  {{ $t("help.platform.organization-members.roles.line-46") }}
                </li>
              </ul>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col4' ? 'founded' : ''" v-b-toggle.col4>
              <div>
                {{ $t("help.platform.organization-members.delete.text") }}
              </div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col4" :visible="col == 'col4'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-3">
                {{ $t("help.platform.organization-members.delete.line-1") }}
              </p>

              <!-- <h5 class="mt-5">{{$t("help.organization.create.sample-screen")}}</h5> -->
              <img src="@/assets/images/help/delete-member.png" class="image" />
              <p class="mt-3">
                {{ $t("help.platform.organization-members.delete.line-2") }}
              </p>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      col: "col1",
    };
  },
  mounted() {
    setTimeout(() => {
      const { col } = this.$route.query;
      this.col = col;
      window.scrollTo({ top: 700, behavior: "smooth" });
    }, 500);
  },
};
</script>

<style scoped>
.founded {
  background: yellow !important;
}
.image {
  display: block;
  max-width: 100%;
}
</style>
